import { render, staticRenderFns } from "./HeaderDropdownAccount.vue?vue&type=template&id=01d12e68&"
import script from "./HeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports